import debugLog from '@/debug-log-script-name.js'

$(function() {
  $('body').on('bless', function(e) {
    const $elm = $(e.target)
    let logged = false
    $elm.find('select[multiple].modal').each(function() {
      const $select = $(this)
      if (!logged) {
        debugLog($select, 'activity-modal.js')
        logged = true
      }
      const label = $select.data('label')
      const $options = $select.find('option')
      const $container = $(`
            <div class="activity-container">
                <div class="activity-toggle">
                    <div class="activity-toggle__label">${label}</div>
                </div>
                    <div class="activities-modal" style="display: none;">
                        <div class="activities-modal__header">
                            <div class="activity-modal__search">
                                <input type="search" placeholder="Search"
                                       class="form-element activity-modal__search-input"/>
                                <svg class="icon icon-search-icon">
                                    <use xlink:href="#icon-search-icon"></use>
                                </svg>
                            </div>
                            <button class="button button--default button--close">Close</button>
                        </div>
                        <ul class="activities-modal_list">
                            <li class="activities-modal_list-item activities-modal_list-item--select-all">
                                <label class="activities-modal_label">
                                    <input type="checkbox" class="input--check-all"/>
                                    <span></span>
                                    Select all
                                </label>
                            </li>

                        </ul>
                    </div>
                <div class="activities-modal-backdrop" style="display: none;"></div>
            </div>`)

      const $list = $container.find('ul')
      $options.each(function(index, elm) {
        const $elm = $(elm)

        if (!$elm.val()) {
          return
        }

        const $item = $('<li/>', { class: 'activities-modal_list-item' })
        const checked = $elm.prop('selected') ? 'checked' : ''
        const $checkbox = $(`<div class="form-group">
    <div class="checkboxes">
        <div class="checkbox">
            <label>
                <input type="checkbox" ${checked} />
                <span>
                    <svg class="icon icon-input-checkbox-icon"><use xlink:href="#icon-input-checkbox-icon"></use></svg>
                </span>
                ${$elm.text()}
            </label>
        </div>
    </div>
</div>`)
        $item.append($checkbox)
        $item.data('option', $elm) //bind the option element to the li

        $list.append($item)
      })

      var sync = function() {
        let changed = false
        $container
          .find(
            '.activities-modal_list li:not(.activities-modal_list-item--select-all)',
          )
          .each(function(index, elm) {
            var $li = $(elm)
            var $option = $li.data('option')

            var shouldBeChecked = $li.find(':checkbox').prop('checked')
            changed |= shouldBeChecked != $option.prop('checked')
            $option.prop('selected', shouldBeChecked)
          })

        if (changed) {
          $select.trigger('change')
        }
      }

      $container
        .on('click', '.activity-toggle', function() {
          $('.activities-modal-backdrop').toggle()
          $('.activities-modal').toggle()
        })
        .on('input', '.activity-modal__search-input', function() {
          const target = $(this)
          const activityList = target.closest('.activities-modal')
          const search = target.val().toLowerCase()
          $('.activities-modal_list-item--select-all').hide()
          const $items = activityList.find('.activities-modal_list-item')
          if (!search) {
            $items.show()
            return
          }
          $items.each(function() {
            const text = $(this)
              .text()
              .toLowerCase()
            const match = text.indexOf(search) > -1
            $(this).toggle(match)
          })
        })
        .on('click', '.input--check-all', function() {
          const shouldBeChecked = $(this).prop('checked')
          $container
            .find('.activities-modal_list input:checkbox')
            .prop('checked', shouldBeChecked)
        })
        .on('click', '.button--close', function() {
          $('.activities-modal-backdrop,.activities-modal').hide()
          sync()
        })
        .on('click', '.activities-modal-backdrop', function() {
          $('.button--close').click()
        })
        .on('change', function(event) {
          event.stopPropagation()
        })

      const changeText = function() {
        const numChecked =
          1 *
          $container.find(
            'li:not(.activities-modal_list-item--select-all) [type="checkbox"]:checked',
          ).length

        let formatted = label
        if (numChecked !== 0) {
          formatted += '(' + numChecked + ')'
        }
        $container.find('.activity-toggle__label').text(formatted)
      }
      $select.on('change', changeText)
      $select.hide()
      $select.parent().append($container)
      changeText()
    })
  })
})
